import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { hideLaunchEditOnMobile } from '~commonInfra/utils/MobileHelper';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { editDatasource } from '../../../../datasource/actions/EditDatasourceAction';
import { IDataSourceDetailInfo } from '../../../../datasource/models/IDataSourceInfo';
import { IEditDatasourceAction, ILaunchWebAuthoringAction } from '../../../models/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource, isUsingBridge } from './IEntityActionHelpers';

export const EditDatasourceEntityAction: IEntityAction<IContentInfo<'datasource'>, IEditDatasourceAction> = {
  name: EntityActionNames.EditDatasource,
  translateName: Messages.editDatasource,
  isVisible: (targetItems: IContentInfo[], state: AppState, availableActions: IEditDatasourceAction & ILaunchWebAuthoringAction) => {
    return FeatureFlags.editPublishedDataSourceEnabled
        && targetItems.length === 1
        && !isSingleEmbeddedDatasource(targetItems)
        && !hideLaunchEditOnMobile()
        && availableActions
        && availableActions.launchWebAuthoring
        && availableActions.editDatasource;
  },
  isClickable: (availableActions: IEditDatasourceAction, targetItems: IContentInfo[]) =>
      availableActions
      && availableActions.editAllowedPublishedDatasource
      && !isUsingBridge(targetItems[0] as IDataSourceDetailInfo),
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }

    const item = targetItems[0];
    if (item.contentType === 'datasource') {
      return editDatasource(item, false /* skipPrepCheck */);
    }
  }
};
